import { withInstall } from '@code-monkey-ui/utils'

import Icon from './src/icon.vue'

export const ElIcon = withInstall(Icon)
export default ElIcon

export * from './src/icon'
